import React, { Component } from "react"
import { InputCustom } from "../../components"
import * as ApiHelper from "../../ApiHelper"
import { LoadModal } from "../modais"
export default class RelatorioVigenciasDiasRestantesForm extends Component {
  constructor() {
    super()
    this.onChangeDiasRestantes = this.onChangeDiasRestantes.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      showLoad: false,
      diasRestantes: ""
    }
  }
  onChangeDiasRestantes(event) {
    var newValue = event.target.value
    this.setState({
      diasRestantes: newValue
    })
  }
  sendForm(event) {
    event.preventDefault()
    var params = {
      tipo_relatorio: "Vigencia por dias restantes",
      dias_restantes: this.state.diasRestantes
    }
    this.toggleLoadModal()
    ApiHelper.getRelatorioWith(params, relatorio => {
      this.toggleLoadModal()
      if (relatorio) {
        var url = URL.createObjectURL(relatorio)
        var tempLink = document.createElement("a")
        tempLink.href = url
        tempLink.setAttribute(
          "download",
          "Relatório de vigência por dias restantes.pdf"
        )
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
      } else {
        console.log("Error")
      }
    })
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  render() {
    return (
      <div>
        <div className="row card">
          <LoadModal
            onClose={this.toggleLoadModal}
            show={this.state.showLoad}
          />
          <InputCustom
            sizeClass="col-md-3"
            type="number"
            label={"Dias restantes para o fim do contrato"}
            onChange={this.onChangeDiasRestantes}
            value={this.state.diasRestantes}
          />
          <div className="row">
            <button
              onClick={this.sendForm}
              type="submit"
              className="btn btn-primary pull-left"
              data-background-color="as-blue"
            >
              Gerar
            </button>
          </div>
        </div>
        <span className="label label-primary">
          PS:Se os campos forem deixados em branco, todos os contratos serão
          contemplados
        </span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/relatorios/RelatorioVigenciasDiasRestantesForm.js